const DB_NAME = 'TipsNorgeOffline';
const STORE_NAME = 'pendingReports';
const DB_VERSION = 1;

export interface PendingReport {
    id: string;
    timestamp: number;
    description: string;
    objectDesc: string;
    sceneDesc: string;
    severity: 'LOW' | 'MEDIUM' | 'HIGH';
    location: {
        latitude: number;
        longitude: number;
        municipality: string | null;
    } | null;
    imageBlob: Blob;
    status: 'DRAFT' | 'PENDING_SUBMISSION';
    category?: string;
    phone?: string;
    reporterName?: string;
    isAnonymous?: boolean;
    authority_id?: string;
}

const openDB = (): Promise<IDBDatabase> => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onupgradeneeded = (event) => {
            const db = (event.target as IDBOpenDBRequest).result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: 'id' });
            }
        };

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
};

export const savePendingReport = async (report: Omit<PendingReport, 'id' | 'timestamp'>, existingId?: string): Promise<string> => {
    const db = await openDB();
    const id = existingId || crypto.randomUUID();
    const pendingReport: PendingReport = {
        ...report,
        id,
        timestamp: Date.now()
    };

    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readwrite');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.put(pendingReport); // put() handles both add and update (upsert)

        request.onsuccess = () => resolve(id);
        request.onerror = () => reject(request.error);
    });
};

export const getAllPendingReports = async (): Promise<PendingReport[]> => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readonly');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.getAll();

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
};

export const removePendingReport = async (id: string): Promise<void> => {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const transaction = db.transaction(STORE_NAME, 'readwrite');
        const store = transaction.objectStore(STORE_NAME);
        const request = store.delete(id);

        request.onsuccess = () => resolve();
        request.onerror = () => reject(request.error);
    });
};
